import Blue from "~/core";

new Blue({
	name: 'Video',
	selector: ".video__toggle-mute",
	setup(muteButton) {
		const currentVideo = muteButton.parentElement.querySelector('video');
		const icon = muteButton.querySelector('i');

		function toggleVideoMute() {
			if(currentVideo.muted) {
				currentVideo.muted = false;
				icon.classList.remove('ico-volume_off');
				icon.classList.add('ico-volume_up');
			} else {
				currentVideo.muted = true;
				icon.classList.add('ico-volume_off');
				icon.classList.remove('ico-volume_up');
			}
		}

		this.$addEvents(muteButton, 'click.prevent', (e) => {
			if(currentVideo) {
				toggleVideoMute()
			}
		});
	}
});